export const INVOICE_PRINT_DATA ="INVOICE_PRINT_DATA"
export const BACK_FROM_KIOSK ="BACK_FROM_KIOSK"